/**
 * Produktvarianten-Verwaltung mit Button-Auswahl
 * Unterstützt mehrere Optionen als anklickbare Buttons
 */

document.addEventListener('DOMContentLoaded', function() {
  setupVariantButtons();
  setupFormSubmission();
});

// Varianten-Buttons einrichten
function setupVariantButtons() {
  document.querySelectorAll('.collection-bundle-item .variant-btn').forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const productId = this.dataset.productId;
      const optionIndex = parseInt(this.dataset.optionIndex);
      const optionValue = this.dataset.optionValue;
      const bundleItem = this.closest('.collection-bundle-item');
      
      // Aktualisiere aktiven Button in dieser Option-Gruppe
      const optionContainer = this.closest('.variant-option');
      optionContainer.querySelectorAll('.variant-btn').forEach(btn => {
        btn.classList.remove('active');
        btn.style.backgroundColor = '#2196F3';
      });
      this.classList.add('active');
      this.style.backgroundColor = '#0D47A1';
      
      // Sammle alle ausgewählten Optionen
      const selectedOptions = [];
      bundleItem.querySelectorAll('.variant-option').forEach((option, index) => {
        const activeBtn = option.querySelector('.variant-btn.active');
        if (activeBtn) {
          selectedOptions[index] = activeBtn.dataset.optionValue;
        }
      });
      
      // Finde die passende Variante
      const productData = collectionProductVariants[productId];
      if (!productData) return;
      
      const selectedVariant = productData.variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });
      
      if (selectedVariant) {
        updateProductDisplay(bundleItem, selectedVariant);
      }
    });
  });
}

// Produktanzeige aktualisieren
function updateProductDisplay(bundleItem, variant) {
  // Aktualisiere Varianten-ID
  const variantInput = bundleItem.querySelector('.variant-id');
  if (variantInput) {
    variantInput.value = variant.id;
  }
  
  // Aktualisiere Preis
  const priceDisplay = bundleItem.querySelector('.price-display');
  if (priceDisplay) {
    const formattedPrice = new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    }).format(variant.price / 100);
    priceDisplay.textContent = formattedPrice;
  }
  
  // Aktualisiere Vergleichspreis und Rabatt-Badges
  const priceSection = bundleItem.querySelector('.price-section');
  const priceDiv = bundleItem.querySelector('.price');
  
  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    const comparePrice = new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    }).format(variant.compare_at_price / 100);
    
    // Aktualisiere oder erstelle Vergleichspreis
    let comparePriceDiv = priceDiv.querySelector('.compare-price');
    if (!comparePriceDiv) {
      comparePriceDiv = document.createElement('div');
      comparePriceDiv.className = 'compare-price';
      comparePriceDiv.style.cssText = 'text-decoration: line-through; color: #999; font-size: 0.7em; margin-bottom: 5px;';
      priceDiv.insertBefore(comparePriceDiv, priceDisplay);
    }
    comparePriceDiv.textContent = comparePrice;
    
    // Berechne Ersparnis
    const savings = variant.compare_at_price - variant.price;
    const percentage = Math.round((savings / variant.compare_at_price) * 100);
    const formattedSavings = new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    }).format(savings / 100);
    
    // Aktualisiere oder erstelle Rabatt-Badges
    let savingsBadges = priceSection.querySelector('.savings-badges');
    if (!savingsBadges) {
      savingsBadges = document.createElement('div');
      savingsBadges.className = 'savings-badges';
      savingsBadges.style.cssText = 'display: flex; gap: 5px; flex-wrap: wrap;';
      priceSection.querySelector('div').appendChild(savingsBadges);
    }
    
    savingsBadges.innerHTML = `
      <span style="display: inline-block; background: #4caf50; color: white; padding: 4px 10px; border-radius: 4px; font-size: 0.85em; font-weight: bold;">
        SPARE ${formattedSavings}
      </span>
      <span style="display: inline-block; background: #ff9800; color: white; padding: 4px 10px; border-radius: 4px; font-size: 0.85em; font-weight: bold;">
        -${percentage}%
      </span>
    `;
  } else {
    // Entferne Vergleichspreis und Badges wenn nicht vorhanden
    const comparePriceDiv = priceDiv.querySelector('.compare-price');
    if (comparePriceDiv) comparePriceDiv.remove();
    
    const savingsBadges = priceSection.querySelector('.savings-badges');
    if (savingsBadges) savingsBadges.remove();
  }
  
  // Aktualisiere Verfügbarkeit
  const availabilityDisplay = bundleItem.querySelector('.availability-display');
  const addToCartBtn = bundleItem.querySelector('.add-to-cart-btn');
  
  if (availabilityDisplay) {
    if (variant.available) {
      let html = '<div style="color: #4caf50; font-size: 0.9em; font-weight: 500; margin-bottom: 5px;">✓ Verfügbar</div>';
      
      if (variant.inventory_quantity !== null) {
        html += `<div class="inventory-display" style="color: #666; font-size: 0.85em;">${variant.inventory_quantity} Stück auf Lager</div>`;
        
        // Aktualisiere Max-Menge im Input
        const quantityInput = bundleItem.querySelector('.quantity-input');
        if (quantityInput) {
          quantityInput.max = variant.inventory_quantity;
          if (parseInt(quantityInput.value) > variant.inventory_quantity) {
            quantityInput.value = variant.inventory_quantity;
          }
        }
      }
      
      availabilityDisplay.innerHTML = html;
      
      // Button aktivieren
      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.style.background = '#667eea';
        addToCartBtn.style.cursor = 'pointer';
        addToCartBtn.innerHTML = '🛒 In den Warenkorb';
      }
    } else {
      availabilityDisplay.innerHTML = '<div style="color: #f44336; font-size: 0.9em; font-weight: 500;">✗ Ausverkauft</div>';
      
      // Button deaktivieren
      if (addToCartBtn) {
        addToCartBtn.disabled = true;
        addToCartBtn.style.background = '#ccc';
        addToCartBtn.style.cursor = 'not-allowed';
        addToCartBtn.innerHTML = 'Ausverkauft';
      }
    }
  }
}

// Formular-Submission
function setupFormSubmission() {
  document.querySelectorAll('.collection-bundle-item .product-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Warenkorb aktualisieren
        if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cart) {
          Shopify.theme.cart.getCart();
        }
        
        // Benachrichtigung
        alert('Produkt wurde zum Warenkorb hinzugefügt! 🛒');
        
        // Seite neu laden um Warenkorb zu aktualisieren
        window.location.reload();
      })
      .catch(error => {
        console.error('Fehler:', error);
        alert('Es gab ein Problem beim Hinzufügen zum Warenkorb.');
      });
    });
  });
}

// Für AJAX-Navigation
if (document.addEventListener) {
  document.addEventListener('shopify:section:load', function() {
    setupVariantButtons();
    setupFormSubmission();
  });
}

